var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-cabinet-verification-profile-ip"},[_c('ui-form',{attrs:{"model":_vm.fields,"validation":_vm.$v,"submit-handler":_vm.submit,"gap":"wide"},on:{"update":_vm.updateFormData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }